import * as React from "react"
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import * as styles from "~/styles/blog/three-img-grid.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const ThreeImgGrid = ({ blockId, index }) => {
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block
  const blogTitle = post.title

  const images = []
  if ( notBlank(settings.image1) ) {
    const obj = {
      type: 'image1',
      image: imgSize(settings.image1,900),
      scale: parseInt(settings.scale1),
      mobile_scale: parseInt(settings.mobile_scale1),
      credit: settings.credit1
    }
    images.push(obj)
  }
  if ( notBlank(settings.image3) ) {
    const obj = {
      type: 'image3',
      image: imgSize(settings.image3,900),
      scale: parseInt(settings.scale3),
      mobile_scale: parseInt(settings.mobile_scale3),
      credit: settings.credit3
    }
    images.push(obj)
  }
  if ( notBlank(settings.image2) ) {
    const obj = {
      type: 'image2',
      image: imgSize(settings.image2,900),
      scale: parseInt(settings.scale2),
      mobile_scale: parseInt(settings.mobile_scale2),
      credit: settings.credit2
    }
    images.push(obj)
  }

  return (
    <div className={jnstyls([styles.three, bstyle.sec])} block={block.id}>
      <div className={styles.three_images}>
        {images.map((item, tindex) =>
          <div 
            key={`three_${block.id}${tindex}`}
            className={jnstyls([styles.image, item.type === 'image3' ? styles.image_2row : ''])}
          > 
            {(parseInt(item.scale) < 100 || parseInt(item.mobile_scale) < 100) && (
              <style>
                {item.type === 'image1' ? (   
                  <> 
                    {parseInt(item.scale) < 100 && (
                      `@media only screen and (min-width: 800px) {
                        .img${block.id}_${tindex} {
                          max-width: ${item.scale}%;
                        }
                        .img${block.id}_0 + .${styles.caption} {
                          margin-top: 1.5em;
                          margin-left: 11%;
                        }
                      }`
                    )}
                    {parseInt(item.mobile_scale) < 100 && (
                      `@media only screen and (max-width: 800px) {
                        .img${block.id}_0 {
                          max-width: ${item.mobile_scale}%;
                        }
                      }`
                    )}
                  </>
                ) : (
                  <>
                    {parseInt(item.scale) < 100 && (
                      `@media only screen and (min-width: 800px) {
                        .img${block.id}_${tindex} {
                          max-width: ${item.scale}%;
                        }
                      }`
                    )}
                    {parseInt(item.mobile_scale2) < 100 && (
                      `@media only screen and (max-width: 800px) {
                        .img${block.id}_${tindex} {
                          max-width: ${item.mobile_scale}%;
                        }
                      }`
                    )}
                  </>
                )}
              </style>
            )}

            <img 
              className={jnstyls([styles.img, `img${block.id}_${tindex}`])}
              src={item.image} 
              style={{maxWidth: item.image.includes('SS23') ? 'unset' : ''}}
              alt={notBlank(item.credit) ? item.credit : `${blogTitle} three images - ${tindex + 1}`}
              width={400} height={500} 
            />
            {item.image.includes('HIS_8' ) && (
              <div className={styles.caption} style={{textAlign: 'left'}}>
                Courtesy of Tim Martin
              </div>
            )}
            {notBlank(item.credit) && (
              <div className={styles.credit}>{item.credit}</div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ThreeImgGrid


